module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-wrapper"
  }, [_c('span', {
    staticClass: "timeupdate"
  }, [_vm._v(_vm._s(_vm._f("secToTime")(_vm.timeupdate)))]), _vm._v(" "), _c('div', {
    ref: "barWrapper",
    staticClass: "bar-wrapper"
  }, [_c('div', {
    ref: "bar",
    staticClass: "bar",
    style: ({
      width: (_vm.progress + "%")
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("secToTime")(_vm.time)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-43c208a9"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/progress/progress.vue
// module id = 201
// module chunks = 1